import styled from "styled-components"

import Label from "~/components/atoms/Tag"
import { Color, LineHeight, RadiusSize, SpacingSize, TextSize } from "~/consts/style-mixins"

interface Props {
  date: string
  timeStart: String
  timeEnd: String
  applicationNum: number
  capacityNum: number
  selectsByLottery?: boolean
}

const EventSchduleCard = ({ date, timeStart, timeEnd, applicationNum, capacityNum, selectsByLottery }: Props) => {
  return (
    <StyledSchduleCardWrapper>
      <StyledLeftArea>
        <StyledScheduleCardHeading>開催日時</StyledScheduleCardHeading>
        <StyledHeldOnDate>{date}</StyledHeldOnDate>
        <StyledHeldOnTime>
          {timeStart}〜{timeEnd}
        </StyledHeldOnTime>
      </StyledLeftArea>
      <StyledRightArea>
        <StyledEntryNum>{applicationNum}名</StyledEntryNum>
        <StyledCapacity>/定員{capacityNum}名</StyledCapacity>
        <StyledLabel size="Small" color={Color.Attention}>
          {selectsByLottery ? "抽選" : "先着"}
        </StyledLabel>
      </StyledRightArea>
    </StyledSchduleCardWrapper>
  )
}

const StyledSchduleCardWrapper = styled.div`
  padding: ${SpacingSize.M}px;
  display: flex;
  justify-content: space-between;
  border-radius: ${RadiusSize.Medium}px;
  background-color: ${Color.BackgroundGray};
`

const StyledLeftArea = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
`

const StyledRightArea = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`

const StyledScheduleCardHeading = styled.span`
  margin-bottom: ${SpacingSize["3XS"]}px;
  font-weight: bold;
  color: ${Color.Primary};
`

const StyledHeldOnDate = styled.span`
  margin-bottom: ${SpacingSize["3XS"]}px;
  font-size: ${TextSize.M}px;
  font-weight: bold;
  line-height: ${LineHeight.S}%;
`

const StyledHeldOnTime = styled.span`
  font-size: ${TextSize.S}px;
  color: ${Color.Gray};
`

const StyledEntryNum = styled.span`
  margin-bottom: ${SpacingSize["3XS"]}px;
  font-size: ${TextSize.XL}px;
  font-weight: bold;
`

const StyledCapacity = styled.span`
  margin-bottom: 6px;
  font-size: ${TextSize.XS}px;
  color: ${Color.Gray};
`

const StyledLabel = styled(Label)`
  width: 80px;
  bottom: 8.5px;
  left: 16px;
`

export default EventSchduleCard
